module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bubbletextafteraction":"Tap the microphone button, to ask me a question."},"es":{"bubbletextafteraction":"El reconocimiento de voz está desactivado para el idioma español."}}')
  delete Component.options._Ctor
}
